<template>
  <div class="ph-page">
    <div class="container py-4">
      <SectionHeader label="سجل المدفوعات" title="سجل المدفوعات" subtitle="جميع طلبات الدفع الخاصة بك وحالتها" />

      <div v-if="loading" class="ph-list">
        <div v-for="n in 4" :key="n" class="skel-row"></div>
      </div>

      <div v-else-if="!items.length" class="ph-empty">
        <i class="pi pi-receipt"></i>
        <p>لا توجد مدفوعات بعد.</p>
      </div>

      <div v-else class="ph-list">
        <div v-for="p in items" :key="p.id" class="ph-card">
          <div class="ph-card__main">
            <div class="ph-card__icon"><i class="pi pi-wallet"></i></div>
            <div class="ph-card__info">
              <div class="ph-card__amount">{{ money(p.amount) }}</div>
              <div class="ph-card__meta">
                <span>{{ p.payment_method?.name || 'طريقة دفع' }}</span>
                <span class="dot">·</span>
                <span>{{ date(p.created_at) }}</span>
              </div>
              <div v-if="p.transaction_number" class="ph-card__txn">رقم العملية: {{ p.transaction_number }}</div>
              <div v-if="productName(p)" class="ph-card__product">{{ productName(p) }}</div>
            </div>
          </div>
          <div class="ph-card__side">
            <StatusBadge :text="reqLabel(p.status)" :tone="reqTone(p.status)" />
            <button v-if="p.receipt_image_link" class="ph-receipt" @click="previewImage(p.receipt_image_link)">
              <i class="pi pi-image"></i> الإيصال
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SectionHeader from '@/components/common/SectionHeader.vue';
import StatusBadge from '@/components/subscriptions/StatusBadge.vue';
import { subscriptionService } from '@/services/subscriptionService.js';
import { requestStatusLabel, requestStatusTone, formatMoney, formatDate, typeLabel } from '@/composables/subscriptionMeta.js';

export default {
  name: 'PaymentHistory',
  components: { SectionHeader, StatusBadge },
  data() { return { items: [], loading: true }; },
  methods: {
    reqLabel: requestStatusLabel,
    reqTone: requestStatusTone,
    money: formatMoney,
    date: formatDate,
    productName(p) {
      const s = p.subscription?.subscribable;
      const name = s?.name || s?.title;
      const t = typeLabel(p.subscription?.subscribable_type);
      return name ? `${name} (${t})` : '';
    },
    previewImage(src) {
      Swal.fire({ imageUrl: src, imageAlt: 'الإيصال', showConfirmButton: false, showCloseButton: true, width: 'auto' });
    },
    async load() {
      this.loading = true;
      try { this.items = await subscriptionService.paymentHistory(); }
      catch { this.items = []; }
      finally { this.loading = false; }
    },
  },
  mounted() { this.load(); },
};
</script>

<style scoped>
.ph-page { min-height: 60vh; padding-bottom: 5rem; }
.ph-list { display: grid; gap: .8rem; }
.ph-card { background: #fff; border: 1px solid rgba(91,95,239,.1); border-radius: 14px; padding: 1rem 1.1rem; display: flex; justify-content: space-between; align-items: center; gap: .8rem; }
.ph-card__main { display: flex; gap: .8rem; align-items: center; }
.ph-card__icon { width: 44px; height: 44px; border-radius: 12px; background: rgba(91,95,239,.08); color: #5B5FEF; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; flex-shrink: 0; }
.ph-card__amount { font-weight: 800; color: #111827; font-size: 1.05rem; }
.ph-card__meta { font-size: .8rem; color: #6B7280; display: flex; gap: .35rem; align-items: center; flex-wrap: wrap; }
.ph-card__meta .dot { color: #cbd5e1; }
.ph-card__txn, .ph-card__product { font-size: .76rem; color: #94a3b8; margin-top: .15rem; }
.ph-card__side { display: flex; flex-direction: column; align-items: flex-end; gap: .5rem; }
.ph-receipt { background: rgba(91,95,239,.08); color: #5B5FEF; border: none; border-radius: 8px; padding: .35rem .7rem; font-size: .78rem; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; }
.ph-empty { text-align: center; padding: 3.5rem 1rem; color: #94a3b8; }
.ph-empty .pi { font-size: 2.6rem; display: block; margin-bottom: .8rem; }
.skel-row { height: 82px; border-radius: 14px; background: #e9edf5; position: relative; overflow: hidden; }
.skel-row::after { content: ''; position: absolute; inset: 0; transform: translateX(-100%); background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent); animation: sh 1.3s infinite; }
@keyframes sh { 100% { transform: translateX(100%); } }
</style>
